import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119')
];

export const server_loads = [];

export const dictionary = {
		"/": [28],
		"/about-us": [78],
		"/affiliate": [79,[18]],
		"/aml-policy": [80],
		"/betfeed": [81],
		"/blog": [82],
		"/bonus-terms": [83],
		"/calendar": [84],
		"/casino": [85],
		"/complaints-and-arbitration": [86],
		"/fairness": [87],
		"/faq": [88],
		"/faq/[section]": [89],
		"/game/[game]": [90,[19]],
		"/in": [91],
		"/in/[actionSlug]": [92],
		"/kyc-policy": [93],
		"/leaderboard": [94],
		"/originals": [95],
		"/originals/[game]": [96,[20]],
		"/payment-policy": [99],
		"/privacy-policy": [100],
		"/promotion-page": [101],
		"/promotion-page/race/[...id]": [103,[24]],
		"/promotion-page/[...id]": [102,[23]],
		"/providers": [104],
		"/p/[provider]": [97,[21]],
		"/p/[provider]/[game]": [98,[21,22]],
		"/races/current": [106],
		"/races/last": [107],
		"/races/next": [108],
		"/races/[raceId]": [105],
		"/referral": [109],
		"/responsible-gaming": [110],
		"/special-bets": [112],
		"/special": [111,[25]],
		"/sports": [113,[26]],
		"/sports/[...slug]": [114,[26,27]],
		"/terms-of-service": [115],
		"/terms-sports": [116],
		"/tournaments": [117],
		"/transparency": [118],
		"/vip": [119],
		"/[provider=provider]": [76,[16]],
		"/[lang=lang]": [31,[3]],
		"/[category=category]": [30,[2]],
		"/[lang=lang]/about-us": [36,[3]],
		"/[lang=lang]/affiliate": [37,[3,7]],
		"/[lang=lang]/aml-policy": [38,[3]],
		"/[lang=lang]/betfeed": [39,[3]],
		"/[lang=lang]/blog": [40,[3]],
		"/[lang=lang]/bonus-terms": [41,[3]],
		"/[lang=lang]/calendar": [42,[3]],
		"/[lang=lang]/casino": [43,[3]],
		"/[lang=lang]/complaints-and-arbitration": [44,[3]],
		"/[lang=lang]/fairness": [45,[3]],
		"/[lang=lang]/faq": [46,[3]],
		"/[lang=lang]/faq/[section]": [47,[3]],
		"/[lang=lang]/game/[game]": [48,[3,8]],
		"/[lang=lang]/kyc-policy": [49,[3]],
		"/[lang=lang]/leaderboard": [50,[3]],
		"/[lang=lang]/originals": [51,[3]],
		"/[lang=lang]/originals/[game]": [52,[3,9]],
		"/[lang=lang]/payment-policy": [55,[3]],
		"/[lang=lang]/privacy-policy": [56,[3]],
		"/[lang=lang]/promotion-page": [57,[3]],
		"/[lang=lang]/promotion-page/race/[...id]": [59,[3,13]],
		"/[lang=lang]/promotion-page/[...id]": [58,[3,12]],
		"/[lang=lang]/providers": [60,[3]],
		"/[lang=lang]/p/[provider]": [53,[3,10]],
		"/[lang=lang]/p/[provider]/[game]": [54,[3,10,11]],
		"/[lang=lang]/races/current": [62,[3]],
		"/[lang=lang]/races/last": [63,[3]],
		"/[lang=lang]/races/next": [64,[3]],
		"/[lang=lang]/races/[raceId]": [61,[3]],
		"/[lang=lang]/referral": [65,[3]],
		"/[lang=lang]/responsible-gaming": [66,[3]],
		"/[lang=lang]/special-bets": [68,[3]],
		"/[lang=lang]/special": [67,[3,14]],
		"/[lang=lang]/sports": [69,[3]],
		"/[lang=lang]/sports/[...slug]": [70,[3,15]],
		"/[lang=lang]/terms-of-service": [71,[3]],
		"/[lang=lang]/terms-sports": [72,[3]],
		"/[lang=lang]/tournaments": [73,[3]],
		"/[lang=lang]/transparency": [74,[3]],
		"/[lang=lang]/vip": [75,[3]],
		"/[lang=lang]/[provider=provider]": [34,[3,5]],
		"/[lang=lang]/[category=category]": [33,[3,4]],
		"/[lang=lang]/[provider=provider]/[game]": [35,[3,5,6]],
		"/[provider=provider]/[game]": [77,[16,17]],
		"/[lang=lang]/[...fallback]": [32,[3]],
		"/[...fallback]": [29]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';